<template>
    <!-- Typed-in emails as chips (shared .chip-editor styles); with show-locations, each email has the locations it's for -->
    <div class="chip-editor">
        <div class="chip-editor-h">
            <h3>{{ label }}</h3>
            <span class="chip-editor-count">{{ modelValue.length }}</span>
        </div>
        <div v-if="hint" class="chip-editor-hint">{{ hint }}</div>
        <form class="chip-editor-add" @submit.prevent="add()">
            <input type="text" v-model="input" placeholder="Add email..." />
            <button class="btn" aria-label="Add email"><svg-icon icon="plus" /></button>
        </form>
        <!-- Without locations the chips wrap side by side; with them, one row per email with its locations beside it -->
        <div v-if="modelValue.length" :class="['rcp-list', { 'rcp-list-locs': showLocations }]">
            <div v-for="(em, i) in modelValue" :key="i" class="rcp-item">
                <span class="tag-chip">
                    {{ em.email }}
                    <button type="button" class="tag-chip-x" :aria-label="'Remove ' + em.email" title="Remove" @click="remove(i)"><svg-icon icon="x" /></button>
                </span>
                <div v-if="showLocations" class="chip-editor-item-opts">
                    <label v-for="(loc, j) in $store.state.user.locations" :key="'l'+j" class="checkbox-input">
                        <input type="checkbox" v-model="em.locations[loc]" />
                        <span>{{ loc }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default defineComponent({
    name: 'EmailRecipientsEditor',
    components: {
        SvgIcon
    },
    emits: [ 'update:modelValue' ],
    props: {
        // [{ email, locations: { [location]: true } }], or [{ email }] without show-locations
        modelValue: { type: Array as () => any[], required: true },
        label: { type: String, required: true },
        hint: { type: String, default: '' },
        showLocations: { type: Boolean, default: false }
    },
    data() {
        return {
            input: ''
        }
    },
    methods: {
        add() {
            const email = this.input.trim();
            if(!email) {
                return;
            }
            this.$emit('update:modelValue', [ ...this.modelValue, this.showLocations ? { email, locations: {} } : { email } ]);
            this.input = '';
        },
        remove(i: number) {
            this.$emit('update:modelValue', this.modelValue.filter((em: any, j: number) => j != i));
        }
    }
});
</script>
